import { useEffect, useState, useCallback } from "react";
import { getCachevalue, localGetItem } from "../../../../Utility/Services/CacheProviderService";
import { ImagePaths } from "../../../../Utility/ImagePaths";
import PackageDeatailPop from "../../../../Components/Common Components/PackageDeatailPop";
import RestAPIService from "../../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../../Utility/API/Serviceurls";
import CommonGridHeader, { CommonPatientCard, CommonPatientDetails, ConsultantPatientCard } from "../../../../Components/Common Components/CommonComponents";
import { Box, Button, TextField, InputAdornment } from "@mui/material";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { formatDate, timeOnlyConvert } from "../../../../Components/CommonFunctions/CommonFunctions";
import ToastMsg from "../../../../Components/ToastMsg/ToastMsg";
import { Colors } from "../../../../Styles/Colors";

const OTList = () => {
    const { t } = useTranslation();

    // fetch the patient data from the cache
    let patientDataFromCache = JSON.parse(getCachevalue('IppatientData') || '{}');
    let loggedInUserInfo = JSON.parse(localGetItem("loggedInUserInfo") || '{}');
    let ClinicID = loggedInUserInfo?.clinic_id;

    const [state, setState] = useState({
        ipPatientData: patientDataFromCache,
        OTRequestData: [],
        PackageDetailPopVisible: false,
        isLoader: false,
        successMsg: false,
        successMsgText: "",
        isErrorMsg: false,
        isErrorMsgText: "",
        selectedOTRequest: null,
        isEdit: false,
        isOTRequested: false
    });

    const GetOTRequestReports = useCallback(() => {
        if (!state.ipPatientData?.patient_id) return;

        setState((prev) => ({ ...prev, isLoader: true }));
        try {
            RestAPIService.getAll(Serviceurls.FO_PATIENT_DETAILS_IP_ACTION + "?ip_admission_id=" + state.ipPatientData?.id + "&from_ip=true")
                .then((response) => {
                    if (response.data.status === "success") {
                        setState((prev) => ({
                            ...prev,
                            OTRequestData: response.data.data || [],
                            isLoader: false,
                            isOTRequested: response.data.move_to_ot_request || false,
                        }));
                    } else {
                        setState((prev) => ({ ...prev, isLoader: false }));
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message);
                    setState((prev) => ({ ...prev, isLoader: false }));
                })
        } catch (error) {
            errorMessage(error.message);
            setState((prev) => ({ ...prev, isLoader: false }));
        }
    }, [state.ipPatientData?.patient_id]);

    useEffect(() => {
        GetOTRequestReports();
    }, []);

    const errorMessage = (message) => {
        setState((prev) => ({
            ...prev,
            isErrorMsg: true,
            isErrorMsgText: message,
            isLoader: false
        }));
    };

    const successMessage = (message) => {
        setState((prev) => ({
            ...prev,
            successMsg: true,
            successMsgText: message,
            isLoader: false
        }));
    };

    const postIpRequest = (packageData) => {
        let admissionID = state?.ipPatientData?.id;

        try {
            let data = packageData ? {
                ...packageData,
                ip_admission_id: admissionID,
                move_to_ot_request: true,
                is_ready_for_final_bill: false,
                is_ip_ot_request: true,
            } : {
                ip_admission_id: state.ipPatientData?.id || null,
                status: "Cancelled"
            };

            if (state.isEdit && state.selectedOTRequest) {
                if (state.selectedOTRequest.ot_admission_id) {
                    data.ot_admission_id = state.selectedOTRequest.ot_admission_id;
                } else if (state.selectedOTRequest.id) {
                    data.ot_admission_id = state.selectedOTRequest.id;
                }
            }

            if (!data.clinic_id) data.clinic_id = ClinicID;

            if (state.isEdit) {
                RestAPIService.updateWithOutId(data, Serviceurls.FO_PATIENT_DETAILS_IP_ACTION)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            successMessage(response.data.message);
                            setState((prev) => ({ ...prev, PackageDetailPopVisible: false, isEdit: false, selectedOTRequest: null }));
                            GetOTRequestReports();
                        }
                    }).catch((error) => {
                        errorMessage(error?.response?.data?.message || error?.message);
                    });
            } else {
                RestAPIService.create(data, Serviceurls.FO_PATIENT_DETAILS_IP_ACTION)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            successMessage(response.data.message);
                            setState((prev) => ({ ...prev, PackageDetailPopVisible: false, isEdit: false, selectedOTRequest: null }));
                            GetOTRequestReports();
                        }
                    }).catch((error) => {
                        errorMessage(error?.response?.data?.message || error?.message);
                    });
            }

        } catch (e) {
            errorMessage(e?.message);
        }
    };

    const columns = [
        {
            field: 'surgery_date',
            headerName: t('OT Date & Time'),
            flex: 0.15,
            sortable: true,
            sortComparator: (v1, v2, cellParams1, cellParams2) => {
                const row1 = cellParams1.api.getRow(cellParams1.id) || {};
                const row2 = cellParams2.api.getRow(cellParams2.id) || {};
                const d1 = row1.surgery_date ? new Date(row1.surgery_date + (row1.surgery_time ? ' ' + row1.surgery_time : '')).getTime() : 0;
                const d2 = row2.surgery_date ? new Date(row2.surgery_date + (row2.surgery_time ? ' ' + row2.surgery_time : '')).getTime() : 0;
                return d1 - d2;
            },
            renderCell: (params) => (
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%' }}>
                    <Box sx={{ fontSize: '0.85vw' }}>{params.row.surgery_date ? formatDate(params.row.surgery_date) : '-'}</Box>
                    <Box sx={{ fontSize: '0.75vw', color: 'gray' }}>{params.row.surgery_time ? timeOnlyConvert(params.row.surgery_time) : ''}</Box>
                </Box>
            )
        },
        { field: 'surgery_name', headerName: t('Surgery'), flex: 0.15, renderCell: (params) => params.value || '-' },
        { field: 'surgeon_name', headerName: t('Surgeon'), flex: 0.12, renderCell: (params) => params.value || '-' },
        { field: 'anaesthetist', headerName: t('Anaesthetist'), flex: 0.12, renderCell: (params) => params.value || '-' },
        { field: 'ot_name', headerName: t('OT'), flex: 0.1, renderCell: (params) => params.value || '-' },
        { field: 'slot_name', headerName: t('Slot'), flex: 0.08, renderCell: (params) => params.value || '-' },
        { field: 'current_stage', headerName: t('Status'), flex: 0.1, renderCell: (params) => params.value || 'Pending' },
        {
            field: 'action',
            headerName: t('Action'),
            flex: 0.08,
            sortable: false,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                    <Button
                        size="small"
                        variant="contained"
                        disabled={params.row.current_stage !== 'Pending'}
                        sx={{ minWidth: 'unset', p: 0.5, backgroundColor: params.row.current_stage !== 'Pending' ? '#B0B0B0' : '#04B7B1', '&:hover': { backgroundColor: params.row.current_stage !== 'Pending' ? '#B0B0B0' : '#04B7B1', opacity: 0.9 } }}
                        onClick={() => {
                            setState((prev) => ({
                                ...prev,
                                PackageDetailPopVisible: true,
                                isEdit: true,
                                selectedOTRequest: params.row
                            }));
                        }}
                    >
                        <img src={ params.row.current_stage !== 'Pending' ? ImagePaths.DisabledEdit.default : ImagePaths.Edit.default} alt="edit" style={{ width: '1vw' }} />
                    </Button>
                </Box>
            )
        }
    ];

    const { ipPatientData, OTRequestData, PackageDetailPopVisible } = state;

    // Check last row: show Create OT button when last row status is Completed || cancelled; otherwise keep it disabled
    const firstRow = OTRequestData.length > 0 ? OTRequestData[0] : null;
    const firstRowIsCompleted = firstRow && (firstRow.current_stage === 'Completed' || firstRow.current_stage === 'Cancelled');
    const isCreateOTDisabled = OTRequestData.length > 0 && !firstRowIsCompleted;

    let attender = {
        lineOne: t("AttenderName"),
        lineTwo: `${ipPatientData?.attender_name ? ipPatientData.attender_name : '-'}`,
        lineFour: t('ContactNumber'),
        LineFive: `${ipPatientData?.attender_mobile ? ipPatientData.attender_mobile : '-'}`
    };

    let consultant = {
        lineOne: t("ConsultantName"),
        lineTwo: `${ipPatientData?.doctor_name ? ipPatientData.doctor_name : '-'}`,
    };

    return (
        <Box sx={{ p: 1, backgroundColor: '#fff', height: '100%' }}>
            {/* patient details */}
            <Box component={'div'} className='eMed_patient_header' sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box className='eMed_Patient_Details_Long eMed_patient_box'>
                        <CommonPatientDetails data={ipPatientData} showDetailed={true} />
                    </Box>
                    <CommonPatientCard details={attender} showDetailed={true} />
                    <ConsultantPatientCard name={consultant} />
                </Box>
                <Box sx={{ ml: 'auto', mr: 2 }}>
                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: isCreateOTDisabled ? '#B0B0B0' : (Colors.Primary || '#04B7B1'),
                            color: '#fff',
                            textTransform: 'none',
                            fontSize: '0.9vw',
                            px: 3,
                            fontWeight: 600,
                            '&:hover': { backgroundColor: isCreateOTDisabled ? '#B0B0B0' : (Colors.Primary || '#04B7B1'), opacity: 0.9 }
                        }}
                        disabled={isCreateOTDisabled}
                        onClick={() => setState((prev) => ({ ...prev, PackageDetailPopVisible: true, isEdit: false, selectedOTRequest: null }))}
                    >
                        {t("Create OT")}
                    </Button>
                </Box>
            </Box>

            <Box border={'1px solid lightgray'} mt={'1vw'} height={'31vw'} mr={'0.5vw'} overflow={'scroll'}>
                <DataGrid
                    loading={state.isLoader}
                    rows={OTRequestData}
                    columns={columns}
                    getRowId={(row) => row['surgery_request_id']}
                    pageSize={10}
                    rowsPerPageOptions={[10]}
                    disableSelectionOnClick
                    rowHeight={50}
                    headerHeight={40}
                    pagination
                    sortingMode="client"
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: CommonGridHeader.CommonToolBar,
                        NoRowsOverlay: () => (
                            <Box className='eMed_conf_nodata'>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    sx={{
                        border: 'none',
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: Colors.DataTblHeaderbg || '#FAF9F9',
                            color: '#616161',
                            fontSize: '0.9vw',
                            fontWeight: 600
                        },
                        '& .MuiDataGrid-cell': {
                            fontSize: '0.85vw'
                        }
                    }}
                />
            </Box>

            {/* pop up for ot request */}
            {PackageDetailPopVisible && (
                <PackageDeatailPop
                    fromIpToOTRequest={true}
                    isEdit={state.isEdit}
                    PatientDetails={state.isEdit && state.selectedOTRequest ? { ...ipPatientData, ...state.selectedOTRequest, insurance_company_name: ipPatientData.insurance_name || null } : {...ipPatientData, insurance_company_name: ipPatientData.insurance_name || null}}
                    ClinicID={ClinicID}
                    ErrorMsg={errorMessage}
                    SuccessMsg={successMessage}
                    proceedBtnAction={postIpRequest}
                    handleClose={() => setState((prev) => ({ ...prev, PackageDetailPopVisible: false, isEdit: false, selectedOTRequest: null }))}
                    emed_tid="ot_ip_request_package_detail_popup"
                />
            )}

            {state.isErrorMsg && (
                <ToastMsg
                    severity='error'
                    msg={state.isErrorMsgText}
                    msgPop={() => setState((prev) => ({ ...prev, isErrorMsg: false }))}
                />
            )}
            {state.successMsg && (
                <ToastMsg
                    severity='success'
                    msg={state.successMsgText}
                    msgPop={() => setState((prev) => ({ ...prev, successMsg: false }))}
                />
            )}
        </Box>
    );
};

export default OTList;